<template>
  <form
    @submit.prevent="submit"
  >
    <div class="control control_round">
      <input
        v-model="email"
        type="email"
        placeholder="Insert your email address"
        required
      >
    </div>

    <TButton
      type="submit"
      variant="orange"
      :loading="isLoading"
    >
      Unlock course
    </TButton>
  </form>
</template>

<script>

import { email, required } from 'vuelidate/lib/validators';
import userMessages from '@/mixins/user-messages';
import TButton from '@/components/base/TButton/TButton.vue';


export default {
  name: 'UnlockCourseForm',
  components: { TButton },
  mixins: [userMessages],
  validations: {
    email: {
      email,
      required,
    },
  },
  data() {
    return {
      email: '',
      isLoading: false,
    };
  },
  methods: {
    async submit() {
      if (this.$v.email.$invalid) {
        return;
      }
      this.isLoading = true;
      this.$emit('submit', {
        email: this.email,
        cb: () => {
          this.isLoading = false;
        },
      });
    },
  },
};
</script>

<style
  scoped
  lang="scss"
>
@import "~@/assets/scss/mixins";

form {
  display: flex;
  flex-direction: column;
  gap: 16px;

  @include media-lg() {
    flex-direction: row;
    gap: 8px;
  }
}

.control {
  @include media-lg() {
    flex-grow: 1;
  }
}

</style>
